export * from './header.component';


// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/components/header/index.ts